import React from "react";

import {LeadModel} from "@/typings/models/Lead";
import PrettyDate from "@/components/PrettyDate";

import styles from "./index.less"
import {F, INTL_ATTRIBUTE, INTL_ENTITY} from "@/utils/intl";

const LeadCustomerCreatedAt = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  if (!lead?.customer?.created) return <div> - </div>
  const content = <PrettyDate absolute date={lead.customer.created} />

  if (isTable) return content

  return <div>
    <div className={styles.tinyDateKey}><F entity={INTL_ENTITY.CUSTOMER} attribute={INTL_ATTRIBUTE.CREATED_AT}/></div>
    <div>{content}</div>
  </div>

}

export default LeadCustomerCreatedAt
